const route = {
	path: ':subsidiaryId/:moduleId/edit-accounting',
	name: 'page-edit-accounting',
	meta: {
		title: 'Editar Asiento',
	},
	component: () => import('@/pages/accounting-periods/page-edit-accounting'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/edit-accounting.js